/**
 * Renders the header used for each section of the landing page
 *
 * Copyright (c) 2022 Propellant Software Corp
 * Author: Kelvin Nguyen
 */

import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import ExploreButton from '../ExploreButton'
import styles from './SectionHeader.module.scss'

const SectionHeader = ({ className, title, description, exploreUrl }) => (
  <div className={cx(className, styles['section-header-container'])}>
    <div className={cx(styles['title-container'])}>
      <h2 className='font-h3 font-weight-semibold'>{title}</h2>
      {exploreUrl && (
        <span className='desktop-only'>
          <ExploreButton url={exploreUrl} dark />
        </span>
      )}
    </div>
    <h3 className='font-h4 mt-2'>{description}</h3>
  </div>
)

SectionHeader.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  exploreUrl: PropTypes.string
}

export default SectionHeader
